<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      label-width="100px;"
      label-position="top"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row>
        <el-form-item
          :label="$l('form_label_userGroupName') || '分组名称'"
          prop="userGroupName"
        >
          <el-input
            v-model="formData.userGroupName"
            clearable
            :placeholder="
              $l('form_placeholder_userGroupName') || '请输入分组名称'
            "
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          :label="$l('form_label_userList') || '分组成员'"
          prop="userList"
        >
          <el-transfer
            style="height:80%"
            v-model="formData.userList"
            :data="transferData"
            :titles="['All', 'Selected']"
          ></el-transfer>
        </el-form-item>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('tips_question_save') || '是否要保存更改?' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('btn_cancel') || '取消'
        }}</el-button>
        <el-button size="small" @click="close()">{{
          $l('btn_no_save') || '不保存'
        }}</el-button>
        <el-button type="primary" size="small">{{
          $l('btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    code: {
      type: String,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      transferData: [],
      formData: {
        userList: [],
      },
      backDialogVisible: false,
      rules: {
        userGroupName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_userGroupName') || '请输入分组名称',
            trigger: 'blur',
          },
        ],
        userList: [
          {
            required: true,
            message: this.$l('form_placeholder_userList') || '请选择分组成员',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    this.loadTransferData()
  },
  mounted() {
    this.loadFormData()
  },
  methods: {
    loadFormData() {
      if (!this.code) return
      this.$api
        .baseUserGroupDetailApi({ userGroupCode: this.code })
        .then((res) => {
          this.formData = res.body
        })
    },
    loadTransferData() {
      this.$api.baseUserTransferDataApi().then((res) => {
        this.transferData = res.body.data
      })
    },
    cancel() {
      this.backDialogVisible = true
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      this.$api.baseUserGroupSaveApi(this.formData).then((res) => {
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'success',
        })
        this.$emit('close')
        this.$emit('reload')
      })
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
